import React, { ReactNode } from 'react';

export interface Props {
  /** Unique id for the trigger; the tooltip content is exposed to assistive tech via `aria-describedby`. */
  id: string;
  /** Tooltip message. Pass already-translated copy from the consumer's own `t()`. */
  content: ReactNode;
  /** The hover/focus target, typically an icon. */
  children: ReactNode;
  className?: string;
  /** Accessible name for the trigger when children is an icon with no visible text. */
  'aria-label'?: string;
}

const Tooltip = ({ id, content, children, className, 'aria-label': ariaLabel }: Props): JSX.Element => (
  <span
    id={id}
    role='button'
    tabIndex={0}
    aria-label={ariaLabel}
    aria-describedby={`${id}-content`}
    className={`relative inline-flex group cursor-help focus:outline-none focus-visible:ring-2 focus-visible:ring-sapphire${className ? ` ${className}` : ''}`}
  >
    {children}
    <span
      id={`${id}-content`}
      role='tooltip'
      className='pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block group-focus:block w-64 bg-neutral-800 text-white text-xs rounded px-3 py-2 z-20 text-center'
    >
      {content}
    </span>
  </span>
);

export { Tooltip };
